<template>
  <nav class="mainMenu container">
    <div v-if="show" @click="menuToggle" class="menuCloserOverlay"></div>
    <!-- Overlay over rest of page to allow closing of menu -->
    <ul
      class="nav justify-content-left flex-column flex-md-row navbar navbar-expand-md" style="z-index:9999999;"
      :class="{expanded:show}"
    >
      <div class="d-lg-none btn btn-primary btn-sm m-2" @click="menuToggle">x Close Menu</div>

      <li class="d-md-none nav-item auth-item" v-if="$store.state.auth.loggedIn">
        <router-link 
          :to="{name: 'account'}" 
          class="nav-link"
        >
            My Account
        </router-link>
      </li>

      <li class="d-md-none nav-item auth-item" v-if="$store.state.auth.loggedIn">
        <router-link 
          :to="{name: 'accountFavourites'}" 
          class="nav-link"
        >
          My Favourites
        </router-link>
      </li>

      <li class="nav-item" v-for="(route, index) in routes" :key="index">

        <router-link
          :to="route"
          :exact="route.menu.title=='Home'"
          class="nav-link menu-link"
          :class="{hasChildren: route.children && route.children.length > 0}"
        >
          {{ route.menu.title }}
        </router-link>
        
        <div 
          class="triangle"
          v-if="route.children && route.children.length >0 || (('meta' in route) && !('flyover' in route.meta) && route.meta.flyover)"
          @click="toggleSubMenu"
        >

        </div>

        <ul 
          v-if="route.children && route.children.length >0 " 
          class="submenu"
        >
          <li 
            v-for="(child, index) in route.children" 
            :key="index" 
            class
          >
            <!-- {{child.}} -->
            <router-link
              :to="route.path + '/' +  child.path"
              :class="{hasChildren: child.children && child.children.length > 0}"
            >
              {{child.menu.title}}
            </router-link>

            <div 
              class="triangle subsubmenuTriangle"
              v-if="child.children && child.children.length > 0"
              @click="toggleSubSubMenu"
            >

            </div>

            <ul 
              v-if="child.children && child.children.length > 0" 
              class="subsubmenu"
            >
              <li 
                v-for="(subchild, subindex) in child.children" 
                :key="subindex"
              >
                <router-link
                  :to="route.path+'/'+child.path+'/'+subchild.path"
                >
                  {{subchild.menu.title}}
                </router-link>
              </li>
            </ul> <!-- Submenu End -->

          </li>
        </ul>
        <FlyOverMenu 
          v-if="'meta' in route && 'flyover' in route.meta && route.meta.flyover"
          :flyOverDataType="route.meta.flyoverContent"
          :route="route"
        />
      </li>
      <li class="ml-auto d-none d-lg-block">
        <router-link :to="{name: 'signup'}" class="btn btn-primary" v-if="showSignup">Sign Up</router-link>
        <router-link :to="{name: 'gold-signup'}" class="btn btn-primary" v-else-if="showJoinGold">Join Gold</router-link>
      </li>

		<!-- Mobile Extra Items -->
		<!-- Logged in -->

		<li class="d-lg-none nav-item auth-item" v-if="$store.state.auth.loggedIn">
			<router-link :to="{name:'get-a-price'}" class="noStyle nav-link red">Request a Price</router-link>
		</li>
		<li class="d-lg-none nav-item auth-item" v-if="$store.state.auth.loggedIn">
			<router-link :to="{name:'accountGoldUpgrade'}" class="noStyle nav-link gold">Upgrade</router-link>
		</li>
		<li class="d-md-none nav-item auth-item" v-if="$store.state.auth.loggedIn">
			<a href="#" @click="redirectLogout()" class="noStyle nav-link red">Log Out</a>
		</li>

      <!-- Logged out -->
      <li class="d-lg-none nav-item auth-item" v-if="!$store.state.auth.loggedIn">
        <router-link :to="{name:'login'}" class="noStyle nav-link green">Log In</router-link>
      </li>
      <li class="d-lg-none nav-item auth-item" v-if="!$store.state.auth.loggedIn">
        <router-link :to="{name:'signup'}" class="noStyle nav-link green">Sign Up</router-link>
      </li>
		<router-link :to="{name: 'accountGoldUpgrade'}" class="d-none d-lg-block btn btn-primary btn-upgrade" v-if="$store.state.auth.loggedIn && $store.state.auth.memberLevel == 'silver'">Gold</router-link>

    </ul>
  </nav>
</template>

<script>
// import RenewButton from "@/components/RenewButton";
import FlyOverMenu from "@/components/FlyOverMenu"

export default {
  name: "MainMenu",
  components: {
    FlyOverMenu
    // RenewButton
  },
  props: ["show", "menuToggle"],
  methods: {
    doFilter(arr) {
      //filters items in which have menuTitle properties
      let loggedIn = this.$store.state.auth.loggedIn;

      var matches = [];
      if (!Array.isArray(arr)) return matches;

      arr.forEach(i => {
        if (i.hasOwnProperty("menu")) {
          if (loggedIn) {
            if (!i.menu.member) {
              return;
            } else {
              i.menu.title = i.menu.member;
            }
          } else {
            if (!i.menu.public) {
              return;
            } else {
              i.menu.title = i.menu.public;
            }
          }

          let { children, ...item } = i;

          if (children) {
            let filteredChildren = this.doFilter(children);
            item["children"] = filteredChildren;
          }
          matches.push(item);
        }
      });

      return matches;
    },
    redirectLogout() {
      this.$store.dispatch("auth/logout").then(() => {
        if (this.$route.name == "home") {
          this.$router.push({ name: "home" });
          this.$router.go(0);
        } else {
          this.$router.push({ name: "home" });
          this.$router.go(1);
        }
      });
    },
    toggleSubMenu(e) {
      let els = document.getElementsByClassName("openSubMenu");
      let triangle = e.target;
      if(triangle.nextSibling.classList == "submenu") {  // If the current menu is not open
        for(let el of els) {
          el.classList = "submenu";  // Close all the other ones
        }
        triangle.nextSibling.classList = "submenu openSubMenu";  // Open the selected one
      } else {
        for(let el of els) {
          el.classList = "submenu";  // Otherwise close all the menus
        }
      }
      this.toggleSubMenuTriangle(triangle);
      this.closeSubSubMenus();  // Close all subsubmenus whenever a submenu is toggled
      this.closeSubSubMenuTriangles();
    },
    toggleSubMenuTriangle(t) {
      let els = document.getElementsByClassName("activeTriangle");
      if(t.classList == "triangle") {  // if the current triangle is not rotated
        for(let el of els) {  // Go through all active triangles
          if(!el.classList.contains("subsubmenuTriangle")) {  // if the triangle is not a subsubmenu triangle
            el.classList = "triangle";  // unrotate them
          }
        }
        t.classList = "triangle activeTriangle";
      } else {  // Otherwise close all the non subsubmenu triangles
        for(let el of els) {
          if(!el.classList.contains("subsubmenuTriangle")) {
            el.classList = "triangle";
          }
        }
      }
    },
    toggleSubSubMenu(e) {
      let triangle = e.target;
      if(triangle.nextSibling.classList == "subsubmenu") {  // If the current menu is not open
        this.closeSubSubMenus();
        triangle.nextSibling.classList = "subsubmenu openSubSubMenu";  // Open the selected one
      } else {
        this.closeSubSubMenus();
      }
      this.toggleSubSubMenuTriangle(triangle);
    },
    closeSubSubMenus() {
      let els = document.getElementsByClassName("openSubSubMenu");
      for(let el of els) {
        el.classList = "subsubmenu";  // Close all the other ones
      }
    },
    toggleSubSubMenuTriangle(t) {
      let els = document.getElementsByClassName("activeTriangle");
      if(t.classList == "triangle subsubmenuTriangle") {  // if the current triangle is not rotated
        for(let el of els) {  // Go through all active triangles
          if(el.classList.contains("subsubmenuTriangle")) {  // if the triangle is not a subsubmenu triangle
            el.classList = "triangle subsubmenuTriangle";  // unrotate them
          }
        }
        t.classList = "triangle subsubmenuTriangle activeTriangle";
      } else {  // Otherwise close all the non subsubmenu triangles
        for(let el of els) {
          if(el.classList.contains("subsubmenuTriangle")) {
            el.classList = "triangle subsubmenuTriangle";
          }
        }
      }
    },
    closeSubSubMenuTriangles(){
      let els = document.getElementsByClassName("activeTriangle");
      for(let el of els) {
          if(el.classList.contains("subsubmenuTriangle")) {
            el.classList = "triangle subsubmenuTriangle";
          }
        }
    }
  },
  computed: {
    routes() {
      //return only routes with 'menuTitle' defined
      // console.log(this.$router.options.routes)
      return this.doFilter(this.$router.options.routes);
    },
    showSignup() {
      // console.log(this.$route.path != "/home/gold-membership");
      return this.$route.path != "/home/gold-membership" && !this.$store.state.auth.loggedIn;
    },
    showJoinGold() {
      return this.$route.path == "/home/platinum-membership"
    }
  }
};
</script>

<style scoped lang="scss">
$menuWidth: 300px;
//mobile menu design

@include media-breakpoint-down(md) {

  nav {
    position: fixed;
    top: 0;
    right: -$menuWidth;
    width: $menuWidth;
    height: 100%;
    z-index: 500;
    margin: 0;
  }
  nav > ul {
    display: block;
    width: $menuWidth;
    height: 100%;
    padding: 0;
    // padding-right:20px;
    margin: 0;
    list-style: none;
    background: white; //menu background
    overflow-y: scroll;
    overflow-x: hidden;
    transition: all 200ms ease-in;
    z-index: 500;
    // expanded class added to menu on show
    padding-top: 10px;
    &.expanded {
      transform: translate3d(-$menuWidth, 0, 0);
    }
  }

  nav ul > li.nav-item {
    display: block;
    border-bottom: 1px solid #ddd;
    padding-right: 15px;
    a {
      color: black;
      width: 100%;
      display: inline-block;
      height: 100%;
      padding: 0.5rem 0 0.5rem 0;
    }
  }

  .triangle {
    width: 40px;
    height: 40px;
    display: inline-block;
    float: right;
    z-index: 999;
    position: relative;
    margin-top: -40px;
    padding-right: 5px;
  }
  
  .submenu, .subsubmenu {
    max-height: 0;
    transition: max-height ease-in-out 0.5s;
    overflow: hidden;
  }
  
  .openSubMenu, .openSubSubMenu {
    max-height: 300px;
  }

  .submenu li{
    display: block;
    
    &:last-child {
      padding-bottom: 1rem;
    }
  }

  .subsubmenu {
    padding-bottom: 0;
    li:last-child{
      padding-bottom: 0;
    }
  }
  //overlay to allow clicking off menu to close it
  .menuCloserOverlay {
    z-index: 20;
    background: grey;
    opacity: 0.5;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .nav-item {
    a.red {
		background: $CTred;
		color: white;
		font-weight: bold;
    }
    a.green {
		background: $CTgreen;
		color: white;
		font-weight: bold;
    }
	a.gold {
		background: $CTgold;
		color: white;
		font-weight: bold;
	}
  }
}

@include media-breakpoint-up(lg) {
  .call-us {
    color: $CTred;
    font-size: 12pt;
    display: inline-block;
    vertical-align: middle;
    margin-left: 1.5rem !important;
    margin-right: 1.5rem !important;
    margin-bottom: -4px;
    
  }
  .shopbtn {
    margin-right: 1.5rem !important;
  }

  .shopbtn, .renewbtn {
    padding-left: 15px;
    padding-right: 15px;
  }


  nav {
    margin-bottom: 0;
    padding-left: 0;
    padding-right: 0;
	// max-width: 100%;
  }

  nav ul li.nav-item {
    .submenu {
      display: none;
      border-radius: 5px;
    }
    &:hover .submenu {
      //show subcats on hover
      position: absolute;
      display: block;
    }
    &:hover > .hasChildren:after {
      transform: rotate(45deg);
    }
  }

  .triangle {
    display: none;
  }

  //style top level nav item links
  nav ul li.nav-item > a {
    text-decoration: none;
    border-top: rgba(0, 0, 0, 0) 2px solid;
    transition: border 0.5s;
    padding-top: 10px;
    color: black;

    &.router-link-active,
    &:hover {
      border-top: $CTgreen 2px solid;
    }
  }

  nav ul li > a, nav ul li.nav-item > a{    
    &.hasChildren:after {
      display: inline-block;
      position: relative;
      content: "";
      right: -5px;
    //   margin-left: 10px;
      width: 10px;
      height: 10px;
      transform: rotate(135deg);
      border-right: 2px solid $CTred;
      border-bottom: 2px solid $CTred;
      transition: all ease-in-out 0.1s;
    }
  }

  .submenu {
    list-style: none;
    margin: 0;
    padding: 0;
    min-width: 100px;
    background: white;
    box-shadow: 0px 2px 6px 1px #444;
    z-index: 400;
    li {
      a {
        color: black;
        display: block;

        padding: 3px 10px;
        &.router-link-exact-active {
          text-decoration: underline;
        }
      }
      &:hover .subsubmenu {
        display: block;
      }
      &:hover > .hasChildren:after {
        transform: rotate(45deg);
      }
      &:not(:last-child){
        border-bottom: 1px solid #ddd;
      }
    }
  }

  .subsubmenu {
    display: none;
  }
}

.subsubmenu {
  list-style: none;
}

@include media-breakpoint-down(lg) {
  .menu-link {
    padding: 0.5rem;
    padding-left: 1.5rem !important;
  }

  // .auth-item > a {
  //   padding-left: 1.5rem !important;
  // }

  .call-us {
    // display: inline !important;
    // margin: 0 !important;
    margin-right: 1rem !important;
    margin-left: 0 !important;
    font-size: 12pt;
    display: inline-block;
    line-height: 38px;
    vertical-align: middle;
  }
  .shopbtn{
    margin-right: 1rem !important;

  }

  .shopbtn, .renewbtn {
    padding-left: 10px;
    padding-right: 10px;
  }

  .menu-link {
    padding-right: 0;
  }  

  .nav-link {
    padding-left: 0.5rem !important;
    padding-right: 0.75rem !important;
    &:after {
      margin-left: -6px !important;
    }
  }
}
</style>
